import React from 'react';
import EbookLegacy from './EbookLegacy';
import EbookPageFlip from './EbookPageFlip';

const Ebook = (props) => {
  const usePageFlip =
  props?.template?.usePageFlip ??
  props?.activity?.template?.usePageFlip ??
  false;
  console.log('[EBOOK FACTORY] props.activity =', props.activity);

  return usePageFlip
    ? <EbookPageFlip {...props} />
    : <EbookLegacy {...props} />;
};

export default Ebook;
